$ = jQuery;

// Searches through list and shows word like results
function searchProducts(search, area) {
	// Declare variables
	const input = search;
	const list = area;

	// Find list elements inside all products
	let listElement = list.find('.list-element');
	const filter = input.val().toUpperCase();
	let a, txtValue;

	// Each time key up, go through all list elements and match with search field content
	for (var i = 0; i < listElement.length; i++) {
		a = $(listElement[i]).find('.list-text');
		txtValue = a.text();
		if (txtValue.toUpperCase().indexOf(filter) > -1) {
			listElement[i].style.display = '';
		} else {
			listElement[i].style.display = 'none';
		}
	}
}

function hasCheckedChildren(box) {
	let checkboxes = $(box).find('input[type=checkbox]');
	for (i = 0; i < checkboxes.length; i++) {
		if ($(checkboxes[i]).is(':checked')) {
			return true;
		}
	}
	return false;
}

$(document).ready(function() {
	// Adds searchProducts function to all dropdown boxes
	const dropdowns = $('.dropdown-box');
	for (var i = 0; i < dropdowns.length; i++) {
		let searchInput = $(dropdowns[i]).find('.search-input');
		let searchResults = $(dropdowns[i]).find('.category-box-results');
		searchInput.keyup(function() {
			searchProducts(searchInput, searchResults);
		});
	}

	// Function to show results when clicking btn
	const btns = $('.btn--dropdown');
	for (var i = 0; i < btns.length; i++) {
		btns[i].addEventListener('click', function() {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this)
					.siblings('.dropdown-box')
					.removeClass('active');
			} else {
				$(this).addClass('active');

				$(this)
					.siblings('.dropdown-box')
					.addClass('active');
				$(this)
					.siblings('.dropdown-box')
					.find('.search-input')
					.focus();
			}
		});
	}
});

$(document).click(function(e) {
	const dropdowns = $('.dropdown-box');
	if (!$(e.target).is('.dropdown-box *, .btn--dropdown')) {
		$('.btn--dropdown').removeClass('active');

		for (var i = 0; i < dropdowns.length; i++) {
			if ($(dropdowns[i]).hasClass('active')) {
				$(dropdowns[i]).toggleClass('active');
				if (hasCheckedChildren(dropdowns[i])) {
				} else {
					$(dropdowns[i])
						.siblings('.btn--dropdown')
						.toggleClass('active');
				}
			}
		}
	}
});
